// src/components/SurveyForm/SurveyDescription/SurveyDescription.jsx

import React, { useMemo,useState } from 'react';
import { Button, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
/**
 * Componente para mostrar la descripción de la encuesta
 * Con funcionalidad de "Ver más/menos" en móviles
 */
const SurveyDescription = ({
  description = '',
  maxLength = 150,
  primaryColor = '#03aae4',
  isMobile = false,
  showOnlyOnFirstStep = true,
  currentStep = 0,
}) => {
  const [showFullText, setShowFullText] = useState(false);

  /**
   * Limpia el texto de tags HTML <br/>
   */
  const cleanText = useMemo(() => {
    return description ? description.replace(/<br\/>/g, '\n') : '';
  }, [description]);

  /**
   * Determina el texto a mostrar según el estado
   */
  const displayText = useMemo(() => {
    // Si no es móvil o ya está expandido, mostrar todo
    if (!isMobile || showFullText || !description) {
      return cleanText;
    }

    // Si es móvil y el texto es corto, mostrar todo
    if (cleanText.length <= maxLength) {
      return cleanText;
    }

    // Si es móvil y el texto es largo, truncar
    return `${cleanText.substring(0, maxLength)}...`;
  }, [isMobile, showFullText, description, cleanText, maxLength]);

  /**
   * Verifica si debe mostrar el botón "Ver más/menos"
   */
  const shouldShowButton = useMemo(() => {
    return isMobile && cleanText.length > maxLength;
  }, [isMobile, cleanText.length, maxLength]);

  /**
   * Verifica si debe renderizar el componente
   */
  const shouldRender = useMemo(() => {
    if (showOnlyOnFirstStep && currentStep !== 0) {
      return false;
    }
    return description && description.trim() !== '';
  }, [showOnlyOnFirstStep, currentStep, description]);

  // No renderizar si no cumple las condiciones
  if (!shouldRender) {
    return null;
  }

  /**
   * Maneja el toggle del botón
   */
  const handleToggle = () => {
    setShowFullText((prev) => !prev);
  };

  return (
    <>
      <Typography
        variant="h6"
        style={{
          whiteSpace: 'pre-line',
          textAlign: 'justify',
          fontSize: '15px',
          display: 'block',
          fontStyle: 'italic',
          marginBottom: '50px',
        }}
      >
        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(displayText) }} />
        {/*displayText*/}
      </Typography>

      {shouldShowButton && (
        <Button
          onClick={handleToggle}
          sx={{
            color: primaryColor,
            textTransform: 'none',
            marginTop: '-30px',
            marginBottom: '20px',
            '&:hover': {
              backgroundColor: `${primaryColor}15`, // 15 = transparencia
            },
          }}
        >
          {<span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(showFullText) }} /> ? 'Ver menos' : 'Ver más'}
        </Button>
      )}
    </>
  );
};

export default SurveyDescription;